"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateCompanySchema = exports.CreateCompanySchema = exports.StarkSchema = exports.CnabSchema = exports.BtgsheetSchema = exports.ItausheetSchema = exports.ApiKaminoSchema = exports.ApiInterSchema = exports.CompanyAndBankCodeSchema = exports.CompanySchema = exports.KaminoApiSchema = exports.InterApiSchema = void 0;
const zod_1 = require("zod");
const types_1 = require("./types");
const required = {
    message: 'Campo obrigatório',
};
const validNumber = {
    invalid_type_error: 'Insira um número válido',
    required_error: 'Campo obrigatório',
};
const requiredString = zod_1.z.string({ required_error: 'Campo obrigatório' }).min(1, required);
exports.InterApiSchema = zod_1.z.object({
    certificatePem: requiredString,
    clientId: requiredString,
    clientSecret: requiredString,
    privateKeyPem: requiredString,
});
exports.KaminoApiSchema = zod_1.z.object({
    credential: requiredString,
});
exports.CompanySchema = zod_1.z.object({
    name: requiredString,
    branch: requiredString,
    branch_digit: requiredString,
    account: requiredString,
    account_digit: requiredString,
    cnpj: requiredString,
    address_street: requiredString,
    address_number: zod_1.z.number(validNumber),
    address_complement: zod_1.z.string().optional(),
    address_city: requiredString,
    address_zip_code: requiredString,
    address_state: requiredString,
});
exports.CompanyAndBankCodeSchema = zod_1.z.object({
    bankCode: requiredString,
    labels: zod_1.z.array(zod_1.z.object({ name: zod_1.z.string(), value: zod_1.z.string() })).optional(),
    company: exports.CompanySchema,
});
exports.ApiInterSchema = zod_1.z
    .object({
    type: zod_1.z.literal(types_1.PaymentTypes.API_INTER),
    data: exports.InterApiSchema,
})
    .merge(exports.CompanyAndBankCodeSchema);
exports.ApiKaminoSchema = zod_1.z
    .object({
    type: zod_1.z.literal(types_1.PaymentTypes.API_KAMINO),
    data: exports.KaminoApiSchema,
})
    .merge(exports.CompanyAndBankCodeSchema);
exports.ItausheetSchema = zod_1.z
    .object({
    type: zod_1.z.literal(types_1.PaymentTypes.ITAU_SHEET),
})
    .merge(exports.CompanyAndBankCodeSchema);
exports.BtgsheetSchema = zod_1.z
    .object({
    type: zod_1.z.literal(types_1.PaymentTypes.BTG_SHEET),
})
    .merge(exports.CompanyAndBankCodeSchema);
exports.CnabSchema = zod_1.z
    .object({
    type: zod_1.z.literal(types_1.PaymentTypes.CNAB),
})
    .merge(exports.CompanyAndBankCodeSchema);
exports.StarkSchema = zod_1.z.object({
    type: zod_1.z.literal(types_1.PaymentTypes.STARK),
    bill_transfer_taxes: zod_1.z.boolean(),
    external_account: zod_1.z
        .object({
        environment: zod_1.z.enum(['production', 'sandbox']),
        id: zod_1.z.string(),
        privateKey: zod_1.z.string(),
    })
        .optional(),
});
exports.CreateCompanySchema = zod_1.z.object({
    name: requiredString,
    company_identifier: requiredString,
    config: zod_1.z
        .discriminatedUnion('type', [
        exports.ApiInterSchema,
        exports.CnabSchema,
        exports.StarkSchema,
        exports.ItausheetSchema,
        exports.BtgsheetSchema,
        exports.ApiKaminoSchema,
    ])
        .nullable()
        .optional(),
});
exports.UpdateCompanySchema = zod_1.z.object({
    name: zod_1.z.string(),
    config: zod_1.z
        .discriminatedUnion('type', [
        exports.ApiInterSchema.partial({ data: true }),
        exports.ApiKaminoSchema.partial({ data: true }),
        exports.CnabSchema,
        exports.StarkSchema,
        exports.BtgsheetSchema,
        exports.ItausheetSchema,
    ])
        .nullable()
        .optional(),
});
